// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Suriname */
const SR = /^(?:(?:6[08]|7[1-7]|8[1-9])\d{5})$/;

export default SR;
